import { isIOSApp } from 'utils';
export function getIAPStore() {
    if (isIOSApp()) {
        return CdvPurchase.store;
    }
    // return getFakeIAPStore();
    return null;
}
